import { InteractiveElementActions } from 'aria-viewer/interactive-element'
import ModalTypes from './constants/ModalTypes'

// Actions
export const SET_MODAL_STACK = '|A|ModalActions.SET_MODAL_STACK'
export const OPEN_MODAL = 'ModalActions.OPEN_MODAL'
export const CLOSE_MODAL = 'ModalActions.CLOSE_MODAL'
export const CLOSE_ALL_MODALS = 'ModalActions.CLOSE_ALL_MODALS'

const setModalStack = modalStack => ({
    type: SET_MODAL_STACK,
    modalStack,
})

export const openModal = (type, content) => ({
    type: OPEN_MODAL,
    modal: { type, content },
})

export const closeModal = () => ({ type: CLOSE_MODAL })

export const closeAllModals = () => (dispatch, getState) => {
    var batchedActions = [{ type: CLOSE_ALL_MODALS }]

    if (getState().getIn(['interactiveElements', 'isHotspotModalOpen'])) {
        batchedActions.push({ type: InteractiveElementActions.CLOSE_HOTSPOT_MODAL })
    }
    dispatch(batchedActions)
}

// TODO : not sure what this is. Comments/refactor?
export const openLastSlideAlertModal = () => {
    return (dispatch, getState) => {
        const state = getState()
        const tour = state
            .getIn(['tour', 'tours', 'list'])
            .find(({ tourid }) => tourid == state.getIn(['tour', 'tours', 'current']))

        if (!state.getIn(['modal', 'alert']) && tour.end_tour_message) {
            dispatch(
                openModal(ModalTypes.ALERT, {
                    type: 'alert',
                    title: '',
                    body: tour.end_tour_message,
                    submit: {
                        label: 'OK',
                        action: 'closeModal',
                    },
                })
            )
        }
    }
}

export default {
    SET_MODAL_STACK,
    OPEN_MODAL,
    CLOSE_MODAL,
    CLOSE_ALL_MODALS,
    openModal,
    closeModal,
    closeAllModals,
}
